import { render, staticRenderFns } from "./CardAdvanceTransactions.vue?vue&type=template&id=20379d5b&"
import script from "./CardAdvanceTransactions.vue?vue&type=script&lang=js&"
export * from "./CardAdvanceTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports